var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('tournament-settings-form',[_c('h2',[_vm._v(_vm._s(_vm.$t('tournaments.settings_games')))]),_c(_vm.componentName,_vm._b({tag:"component"},'component',_vm.$attrs,false))],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }